import React, {Component} from 'react';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import TuneIcon from '@material-ui/icons/Tune';
import Button from "@material-ui/core/Button";
import Slider from "@material-ui/core/Slider";
import Tooltip from "@material-ui/core/Tooltip";
import List from "@material-ui/core/List";
import {ListItemText} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";

function valueLabelFormat(value) {
    return value % 1 === 0 ? value :value.toFixed(1) + "%";
}

class CollapsibleAreaCoverageAdvancedOptions extends Component {


    state = {
        open: false,
    }

    handleClick = () => {
        this.setState({
            open: !this.state.open
        })
    }

    componentDidUpdate(prevPros, prevState, snapshot) {
    }

    componentDidMount() {
        // this.setState({
        //     sliderValues: Array.from({length: this.props.numberOfDrones}, (v, i) => 100/this.props.numberOfDrones)
        // })
    }

    render() {

        const {project} = this.props

        return (
            <div >
                <Button onClick={this.handleClick}>
                    <TuneIcon/>Advanced
                    {this.state.open ? <ExpandLess/> : <ExpandMore/>}
                </Button>
                <Collapse in={this.state.open} timeout={"auto"} unmountOnExit>

                    <div >
                        <Divider />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={project.pathsStrictlyInPoly}
                                    onChange={(evt) => this.props.onProjectCheckboxChange("pathsStrictlyInPoly", evt)}
                                    name="pathsStrictlyInPoly"
                                    color="primary"
                                />
                            }
                            label="Paths strictly in ROI"
                        />
                        <Divider />
                        {project.portions ? project.portions.map((elem, index) => (
                            <div>
                        <div>Portion covered of drone {index + 1}</div>
                        <Slider key={index}
                                style={{maxWidth: "100px"}}
                                getAriaValueText={valueLabelFormat}
                                valueLabelFormat={valueLabelFormat}
                                valueLabelDisplay="auto"
                                aria-label="custom thumb label"
                                defaultValue={elem}
                                value={elem}
                                onChange={(evt, newValue) => {
                                    this.props.onPortionsChange(evt, newValue, index)
                                }}
                        />
                            </div>)) : null}
                        {project.portions ? <Divider /> : null}
                    </div>


                </Collapse>
            </div>
        )

    }

}

export default CollapsibleAreaCoverageAdvancedOptions
